var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.097 5.41848C11.3018 5.53644 11.4719 5.70627 11.5902 5.91088C11.7085 6.11549 11.7708 6.34765 11.7708 6.58398C11.7708 6.82032 11.7085 7.05248 11.5902 7.25709C11.4719 7.4617 11.3018 7.63153 11.097 7.74948L2.01805 12.9875C1.81355 13.1057 1.58154 13.1679 1.34536 13.168C1.10917 13.168 0.877133 13.1059 0.672585 12.9878C0.468038 12.8697 0.298192 12.6998 0.180132 12.4953C0.0620718 12.2907 -4.00543e-05 12.0587 4.48227e-05 11.8225V1.34548C-4.00543e-05 1.1093 0.0620718 0.877253 0.180132 0.67269C0.298192 0.468127 0.468038 0.298259 0.672585 0.180173C0.877133 0.0620862 1.10917 -5.47463e-05 1.34536 3.61902e-08C1.58154 5.48187e-05 1.81355 0.0623034 2.01805 0.180485L11.097 5.41848Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlay);
export default __webpack_public_path__ + "static/media/ico-play.c187c666.svg";
export { ForwardRef as ReactComponent };